<template>
    <div id="previewContainer" ref="preview">
        <!--<button type="button" @click="showGrid = !showGrid">Grid</button>-->
        <div class="preview" v-for="(page) in calculatedData">
            <img :class="{ 'imageGrid': showGrid }" :src="getBackgroundImage(page.background)">
            <!-- grid -->
            <div class="gridContainer" v-show="showGrid">
                <span class="rowGridItem" v-for="(r, indexRow) in 80">
                    <span class="colGridItem" v-for="(c, indexCol) in 40" style="padding: 2px;">
                        <span v-if="indexRow == 0">{{ indexCol * 40 }}</span>
                        <span v-if="indexCol == 0">{{ indexRow * 20 }}</span>
                    </span>
                </span>
            </div>
            <!-- end grid -->
            <!-- items -->
            <div class="itemsContainer">
                <span class="item" :class="{ 'itemGrid': showGrid }" v-for="(item in page.items" :style="{ 'font-size': `${item.fs}vw`, 'top': `${item.y}%`, 'left': `${item.x}%`, 'max-width': `${item.mw}%` }">
                    <span v-if="showGrid">
                        {{ item['key'] }}
                    </span>
                    <span v-if="!showGrid">
                        <span class="prv" v-if="item.key != 'signature' && item.key != 'code_type'" v-html="item.value"></span>
                        <span class="prv agency" v-if="item.key == 'code_type'" v-html="`<strong>J. SCHNEEBERGER ${item.value.toUpperCase() || 'SERVICE'} ITALIA srl</strong>`"></span>
                        <span v-if="item.key == 'signature'">
                            <img :src="item.value">
                        </span>
                    </span>
                </span>
            </div>
            <!-- end items -->
        </div>
    </div>
</template>
<script>
    export default {
        name: 'preview-data',
        props: {
            structure: {
                required: true
            },
            items: {
                required: true
            }
        },
        mounted() {
            this.updateCells();
            window.addEventListener("resize", () => {
                this.updateCells();
            });
        },
        data() {
            return {
                height: 0,
                width: 0,
                calculatedData: [],
                showGrid: false
            }
        },
        watch: {
            'items': {
                handler() {
                    this.updateCells();
                },
                deep: true
            },
            'showGrid': {
                handler() {
                    this.updateCells();
                },
                deep: true
            }
        },
        methods: {
            /**
             * Torna l'immagine di background
             */
            getBackgroundImage(page) {
                return require(`@/assets/templates/${page}.jpg`);
            },
            updateCells() {
                // console.log(this.structure);
                /*this.height = (this.$refs.preview) ? (this.$refs.preview.clientHeight || 0) : 0;
                this.width = (this.$refs.preview) ? (this.$refs.preview.clientWidth || 0) : 0;*/
                this.calculatedData = [];
                // ricalcolo i dati in base ai dati ricevuti
                this.structure = this.structure || [];
                this.structure = (this.structure == null) ? [] : this.structure;
                this.structure.map(str => {
                    let showPage = (str.show === true) ? true : false;
                    // se è false controllo se la condizione
                    // è verificata
                    if (!showPage) {
                        let checkShowPage = this.helpers.getObjectData(this.items, str.show);
                        showPage = checkShowPage || false;
                    }
                    // se sono in modalità griglia visualizzo tutte le pagine
                    if (this.showGrid) {
                        showPage = true;
                    }
                    // se la pagina è visibile l'aggiungo
                    if (showPage) {
                        let items = [];
                        // prendo gli elementi
                        str.positions.map(p => {
                            p.type = p.type || 'text';
                            p.maxwidth = p.maxwidth || 100;
                            // se il tipo è checked creo diversi punti
                            if (p.type == 'check') {
                                if (_.isArray(p.x) && _.isArray(p.y)) {
                                    let checkValue = [1, 0, ""];
                                    for (let iPoint = 0; iPoint < p.x.length; iPoint++) {
                                        let value = this.helpers.getObjectData(this.items, p.key, p.type);
                                        value = (value == null) ? "" : value;
										//console.log(`Key: ${p.key}, Value: ${value}`, this.items)
                                        let valueString = "";
                                        if (`_${checkValue[iPoint]}` == `_${value}`) {
                                            valueString = "X";
                                        }
                                        items.push({
                                            key: p.key,
                                            value: valueString,
                                            x: this.getX(p.x[iPoint]),
                                            y: this.getY(p.y[iPoint]),
                                            fs: this.getFont(p.x[iPoint], p.class),
                                            mw: p.maxwidth
                                        });
                                    }
                                } else {
                                    let valueString = "";
                                    let value = this.helpers.getObjectData(this.items, p.key, p.type);
                                    if (value !== undefined && value !== null && value == true) {
                                        valueString = "X";
                                    }
                                    items.push({
                                        key: p.key,
                                        value: valueString,
                                        x: this.getX(p.x),
                                        y: this.getY(p.y),
                                        fs: this.getFont(p.x, p.class),
                                        mw: p.maxwidth
                                    });
                                }
                            } else {
                                if (p.type == 'products') {
                                    let products = this.helpers.getObjectData(this.items, p.key, p.type);

                                    if(str.background == "rapporto_intervento") {
                                        products = products.slice(0, 8);
                                    }


                                    if (this.showGrid) {
                                        products = [
                                            {
                                                'cod': 'C0001',
                                                'des': 'Prodotto 001',
                                                'qta': '999'
                                            },
                                            {
                                                'cod': 'C0002',
                                                'des': 'Prodotto 002',
                                                'qta': '888'
                                            },
                                            {
                                                'cod': 'C0003',
                                                'des': 'Prodotto 003',
                                                'qta': '777'
                                            },
                                            {
                                                'cod': 'C0004',
                                                'des': 'Prodotto 004',
                                                'qta': '666'
                                            },
                                        ]
                                    }
                                    let y = p.y;
                                    products.map((pr, index) => {
                                        let x = p.x;
                                        ['qta', 'cod', 'des'].map((k) => {
                                            items.push({
                                                key: `${p.key}_${index}_${k}`,
                                                value: products[index][k],
                                                x: this.getX(x),
                                                y: this.getY(y),
                                                fs: this.getFont(x, p.class),
                                                mw: p.maxwidth
                                            });
                                            if (k == 'qta') x += 130;
                                            if (k == 'cod') x += 290;
                                        });
                                        y += 27;
                                        y += p.yspace || 0;
                                    });
                                } else {
                                    if(p.key == "sede.customer") {
                                        // controllo che esista
                                        if(this.items.sede && this.items.sede.indirizzo && this.items.sede.indirizzo.length > 0) {
                                            this.items.sede.customer = this.items.customer.agency || "";
                                            this.items.sede.vat_number = this.items.customer.vat_number || "";
                                        } else {
                                        	// una cagata, lo so
                                        	try {
												this.items.sede = JSON.parse(this.items.sede);
												this.items.sede.customer = this.items.customer.agency || "";
												this.items.sede.vat_number = this.items.customer.vat_number || "";
											} catch(e) {}
                                        }
                                    }
                                    let v = this.helpers.getObjectData(this.items, p.key, p.type);
                                    if(v) {
                                        v = v.replace(/\n/g, '<br>');
                                    }
                                    if(p.type == "number") {
                                        if(+v && +v > 0) {
                                            v = +v;
                                        }
                                    }

									if(p.type == "agency") {
										p.class = "agency"

										const varN = {
											"service": "01554140226",
											"macchine": "04436400230"
										}
										items.push({
											key: 'custom_vat_number_ddt',
											value: `${varN[v.toLowerCase()]}`,
											x: this.getX(190),
											y: this.getY(98),
											fs: this.getFont(20, 'agency_vat'),
											mw: p.maxwidth
										});
									}

                                    // è un singolo punto
                                    items.push({
                                        key: p.key,
                                        value: v,
                                        x: this.getX(p.x),
                                        y: this.getY(p.y),
                                        fs: this.getFont(p.x, p.class),
                                        mw: p.maxwidth
                                    });


                                }
                            }
                        });
                        // items.map(i => console.log(`${i.key}: ${i.value}`));
                        // creo l'oggetto della singola pagina
                        this.calculatedData.push({
                            background: str.background,
                            items: items,
                        });
                    }
                });
            },
            getX(w) {
                let perc = (w / 1600) * 100;
                return perc;
            },
            getY(w) {
                let perc = (w / 1600) * 100;
                return perc;
            },
            getFont(w, classItem) {
                let perc = 1;
                switch (classItem) {
                    case 'big':
                        perc = 1.6;
                        break;
                }
                return perc;
            }
        }
    };
</script>
<style lang="scss">
    :root {
        --col: 2.5%;
        --row: 1.25%;
    }

    #previewContainer {
        position: relative;
        height: 500px;
        overflow: scroll;

        .prv {
            font-size: 15px;
            font-family: Arial;
            line-height: 17px;
        }

		.agency {
			font-size: 19px;
			letter-spacing: -1px;
			font-weight: bolder;
			font-family: Arial;
		}
    }

    .preview {
        display: block;
        height: auto;
        border: 2px solid #efefef;
        z-index: 10000000;
        position: relative;

        img {
            width: 100%;
            position: relative;
            z-index: 1;
        }

        .gridContainer {
            position: absolute;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            height: 100%;
            z-index: 2;
            top: 0;
            left: 0;
            opacity: .5;
        }

        .itemsContainer {
            position: absolute;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            height: 100%;
            z-index: 3;
            top: 0;
            left: 0;
        }
    }


    .item {
        position: absolute;
        font-weight: bolder;
        color: #282828;

        .__uppper {
            text-transform: uppercase;
        }
    }

    .itemGrid {
        background: yellow;

        &:before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            border: 2px solid green;
            width: 100%;
            height: 100%;
        }
    }

    .imageGrid {
        opacity: .3;
    }

    .rowGridItem {
        font-size: 10px;
        display: flex;

        width: 100%;
        height: var(--row);

        .colGridItem {
            position: relative;
            display: block;
            width: var(--col);
            height: 100%;
            z-index: 90000;

            &:before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                border: 1px solid red;
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
